/* =========================================================
   FX product page — Kave-style layout (Commune SG, 2 Oct 2026)
   1. Click a grid photo -> theme's zoom viewer (PhotoSwipe).
   2. Sticky details column: sticks under the header; if it is
      taller than the screen it scrolls with the page and sticks
      by its bottom edge instead, so nothing gets cut off.
   ========================================================= */
(function () {
  var zoomReady = false;
  var INFO = '.fx-pdp--kave .page-content--product .grid:has(.fx-grid) > .grid__item:not(:has(.fx-grid))';

  function initZoom() {
    if (zoomReady) return true;
    if (!window.theme || !theme.Photoswipe || !window.PhotoSwipe) return false;
    document.querySelectorAll('[data-fx-grid]').forEach(function (grid) {
      if (grid.dataset.fxZoomBound) return;
      grid.dataset.fxZoomBound = '1';
      new theme.Photoswipe(grid, 'fx-' + grid.dataset.sectionId);
    });
    zoomReady = true;
    return true;
  }

  function headerOffset() {
    var h = document.querySelector('[data-section-type="header"]') || document.querySelector('.site-header');
    if (!h) return 0;
    var el = h.closest('.header-sticky-wrapper') || h;
    var pos = getComputedStyle(el).position;
    var sticky = pos === 'fixed' || pos === 'sticky' || document.body.classList.contains('sticky-header') ||
      !!document.querySelector('.site-header.site-header--stuck, .header-wrapper--sticky');
    if (!sticky) return 0;
    var r = el.getBoundingClientRect();
    return r.bottom > 0 ? Math.round(r.bottom) : 0;
  }

  function updateSticky() {
    document.querySelectorAll(INFO).forEach(function (info) {
      var top = headerOffset() + 20;
      var h = info.offsetHeight;
      var vh = window.innerHeight;
      var value = h + top + 20 <= vh ? top : vh - h - 20;
      info.style.setProperty('--fx-info-top', value + 'px');
    });
  }

  var raf;
  function queue() {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(updateSticky);
  }

  function start() {
    if (!document.querySelector('.fx-pdp--kave')) return;
    if (!initZoom()) window.addEventListener('load', initZoom, { once: true });
    updateSticky();
    window.addEventListener('resize', queue);
    window.addEventListener('scroll', function () {
      // header can shrink / hide on scroll; re-measure cheaply
      queue();
    }, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(queue);
      document.querySelectorAll(INFO).forEach(function (el) { ro.observe(el); });
    }
    // Variant change (product hot-reload) can change the column height
    document.addEventListener('hotreload:updated', queue);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();